import { ROOT_SECTION } from 'shared-base';
import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  background-image: url(${ROOT_SECTION('special')}/special_bk.png);
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const H1 = styled.h1`
  font-family: 'Titillium Web', sans-serif;
  margin: 0;
  padding: 0;
  color: rgb(251, 0, 157);
  font-size: 50px;
`;

export const Tagline = styled.div`
  font-family: 'Titillium Web', sans-serif;
  font-size: 30px;
`;

export const Explain = styled.div`
  font-family: 'Titillium Web', sans-serif;
  font-size: 20px;
`;

export const Image = styled.div`
  background-image: url(${ROOT_SECTION('special')}/special_front-easter.png);
  width: 960px;
  height: 600px;
  margin-top: -90px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top center;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 20px;
`;
